<template>
    <div>
        <div class="show-navigation">
            <chat-header></chat-header>

            <div class="container">
                <chat-menu></chat-menu>

                <div class="form-control-wrapper mb--30">
                    <svg class="icon"><use xlink:href="/img/icon-sprite.svg#search"></use></svg>
                    <input type="text" placeholder="Search" @keyup="search" v-model="query" class="form-control form-control--sm form-control--gray" />
                </div>

                <div class="loader mx--auto mb--20" v-if="showLoader"></div>

                <div class="alert bg--layer-light mb--20" v-if="query.length && ! data.length">
                    No results found.
                </div>

                <template v-for="u in data" v-if="data.length">
                    <div class="profile profile--horizontal profile--horizontal-xs profile--separator">
                        <figure class="profile__avatar profile__avatar--xs mr--sm">
                    <span class="profile__avatar__img">
                        <img :src="u.avatar" alt="">
                        <span v-if="u.is_online" class="status status--success"></span>
                    </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">{{ u.nick }}</div>
                        </div>

                        <div class="profile__buttons">
                            <router-link :to="'/user/' + u.id" class="btn btn--sm btn--default-gray">Profile</router-link>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
import api from "../../api/chat";
import {mapState} from "vuex";
import Navigation from "../partial/Navigation";
import ChatMenu from "./partial/chatMenu";
import ChatHeader from "./partial/chatHeader";
import debounce from "lodash/debounce"

export default {
    name: "AddFriend",

    components: {ChatHeader, ChatMenu, Navigation},

    data: function () {
        return {
            query: '',
            data: [],
            showLoader: false,
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),
    },

    methods: {
        search: debounce(async function () {
            if (this.query.length < 2) {
                this.data = []
                return false
            }

            this.showLoader = true

            try {
                const response = await api.search(this.query)

                this.data = response.data

                this.showLoader = false
            } catch (error) {

            }
        }, 500)
    },

    activated() {
        $('body').addClass('body--white')
    },

    deactivated() {
        $('body').removeClass('body--white')
    }
}
</script>
